import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { Observable, of } from 'rxjs'
import { IconLibrary } from '../gb-icon/gb-icon-library.models'

/**
 * This is a simplified version of the gb-multi-floating-button component
 * use this whenever you need a simple button without any sub-options or secondary actions
 */

@Component({
  selector: 'gb-floating-button',
  templateUrl: './gb-floating-button.component.html',
  styleUrl: './gb-floating-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class GbFloatingButtonComponent {
  @Input() loaded$: Observable<boolean> = of(true)
  @Input() label: string = 'SAVE'
  @Input() labelTranslateParams!: any
  @Input() icon: string = 'save'
  @Input() iconLibrary: IconLibrary = IconLibrary.ionic
}
